import React, { FC, useState } from 'react';
import Slider from 'rc-slider';
import classnames from 'classnames';
import { isArray } from 'lodash';
import { FR_GREY_300, FR_PR_BLUE } from '@shared/styles/vars';
import { numberWithCommas } from '@src/util/numberWithCommas';
import { Props } from './props';
import 'rc-slider/assets/index.css';
import './styles.scss';

const HANDLE_STYLE = [
  {
    backgroundColor: FR_PR_BLUE,
    borderColor: FR_PR_BLUE,
    boxShadow: 'none',
    height: '16px',
    marginTop: '-7px',
    opacity: 1,
    width: '16px',
  },
  {
    backgroundColor: FR_PR_BLUE,
    borderColor: FR_PR_BLUE,
    boxShadow: 'none',
    height: '16px',
    marginTop: '-7px',
    opacity: 1,
    width: '16px',
  },
];
const ACTIVE_DOT_STYLE = {
  border: 'none',
  boxShadow: 'none',
};
const RAIL_STYLE = { backgroundColor: FR_GREY_300, height: '2px' };
const TRACK_STYLE = { backgroundColor: FR_PR_BLUE, height: '2px' };

export const RangeSlider: FC<Props> = props => {
  const {
    wrapperClassName,
    labelsWrapperClassName,
    leftLabelPrefix = '',
    rightLabelPrefix = '',
    leftLabelSuffix = '',
    rightLabelSuffix = '',
    defaultValue,
    min,
    max,
    step,
    onAfterChange,
  } = props;
  const [activeValues, setActiveValues] = useState<number | number[] | undefined>(defaultValue);

  const getLeftLabel = (value: number): string => {
    return `${leftLabelPrefix} ${numberWithCommas(value)} ${leftLabelSuffix}`.trim();
  };

  const getRightLabel = (value: number): string => {
    let result = '';

    if (rightLabelSuffix === '+' && value === max) {
      result = `${rightLabelPrefix} ${numberWithCommas(value)} ${rightLabelSuffix}`;
    } else if (rightLabelSuffix === '+' && value !== max) {
      result = `${rightLabelPrefix} ${numberWithCommas(value)}`;
    } else {
      result = `${rightLabelPrefix} ${numberWithCommas(value)} ${rightLabelSuffix}`;
    }

    return result.trim();
  };

  return (
    <div className={classnames('range-slider-wrapper', wrapperClassName)}>
      <Slider
        activeDotStyle={ACTIVE_DOT_STYLE}
        allowCross={false}
        defaultValue={defaultValue}
        handleStyle={HANDLE_STYLE}
        max={max}
        min={min}
        onAfterChange={value => {
          onAfterChange && onAfterChange(value);
        }}
        onChange={value => {
          if (!isArray(value)) {
            setActiveValues([value]);
          } else {
            setActiveValues(value);
          }
        }}
        railStyle={RAIL_STYLE}
        range
        step={step}
        trackStyle={TRACK_STYLE}
        {...props}
      />
      {Array.isArray(activeValues) && activeValues.length >= 1 && (
        <div className={classnames('range-slider-wrapper__labels', labelsWrapperClassName)}>
          <span>{getLeftLabel(activeValues[0])}</span>
          <span>{getRightLabel(activeValues[1])}</span>
        </div>
      )}
    </div>
  );
};
